import { render, staticRenderFns } from "./commission-deductions.vue?vue&type=template&id=71b7d489"
import script from "./commission-deductions.vue?vue&type=script&lang=js"
export * from "./commission-deductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports